import { updateDraftAmends } from "../amends/controller/update-draft-amends"
import { AuthoringAmendsType } from "../../../lib/enum/authoring-amends-type.mjs"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { PAYLOAD_STATUS_APPROVED, PAYLOAD_STATUS_REJECTED } from "routes/audit/lib/audit-constants.mjs"

// Authoring's implementation of the review-decision port. Decisions are read from a single
// page-level lookup (decisionsByTaskId); the button owns optimistic display state and reverts
// on error, so the provider just persists. record() rethrows so the button can revert.
export function authoringReviewDecisions({ projectId, scheduleId, reviewCycle, decisionsByTaskId }) {
    return { record, getDecision, useDecision: getDecision }

    async function record({ referenceId, shortDescription, payload }) {
        const result = await updateDraftAmends({
            // Omit auditId on purpose: the server derives a canonical id from (referenceId,
            // payload.taskId), so a fresh client GUID can't create duplicate AuthoringAmends
            // rows on remount/double-click (FIQ-1511).
            referenceId,
            shortDescription,
            longDescription: shortDescription,
            payload: { ...payload, projectId, scheduleId, reviewCycle },
            projectId,
            type: AuthoringAmendsType.AUTHORING_AMENDS,
        })
        if (payload?.status === PAYLOAD_STATUS_APPROVED) successSnackbar("Change approved")
        else if (payload?.status === PAYLOAD_STATUS_REJECTED) successSnackbar("Change rejected")
        return result
    }

    function getDecision({ taskId }) {
        return decisionsByTaskId?.get(taskId) ?? null
    }
}
